import { useCallback } from "react";
import { postMessage } from "../core/message";

export interface CurrentLocationCoords {
  latitude: number;
  longitude: number;
}

/**
 * 앱에 현재 위치 요청 후 콜백으로 좌표 전달.
 * maps, location 등 지도 화면에서 공통 사용.
 */
export function useRequestCurrentLocation() {
  return useCallback(
    (onSuccess: (coords: CurrentLocationCoords) => void) => {
      postMessage("REQ_CURRENT_LOCATION", "");
      const receiver = navigator.userAgent.includes("Android")
        ? document
        : window;

      const listener = (event: Event) => {
        try {
          const data = (event as MessageEvent).data;
          const raw = typeof data === "string" ? data : "{}";
          const appData = JSON.parse(raw);
          if (appData?.type === "RES_CURRENT_LOCATION") {
            const coords = appData.data?.coords;
            if (coords?.latitude != null && coords?.longitude != null) {
              onSuccess({
                latitude: coords.latitude,
                longitude: coords.longitude,
              });
            }
            receiver.removeEventListener("message", listener);
          }
        } catch {
          // JSON 파싱 실패 시 무시
        }
      };

      receiver.addEventListener("message", listener);
    },
    []
  );
}
